module.exports = __webpack_public_path__ + "static/img/fontawesome-webfont.912ec66.svg";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 734
// module chunks = 85